import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Popover } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

// type can be hover or click
// content is passed in as children
const CustomPopover = forwardRef(
  (
    { type, customButton, anchorOrigin, transformOrigin, defaultIconStyle, children, ...props },
    ref
  ) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (e) => {
      e.preventDefault();
      setAnchorEl(e.currentTarget);
    };

    const handleClose = (e) => {
      e.preventDefault();
      setAnchorEl(null);
    };

    useImperativeHandle(ref, () => ({
      handleOpen: () => {
        setAnchorEl(e.currentTarget);
      },

      handleClose: () => {
        setAnchorEl(null);
      },
    }));

    return (
      <>
        {customButton ? (
          <span
            onMouseEnter={type === 'hover' ? handleOpen : null}
            onMouseLeave={type === 'hover' ? handleClose : null}
            onClick={type === 'click' ? (open ? handleClose : handleOpen) : null}
          >
            {customButton}
          </span>
        ) : (
          <InfoIcon
            style={{ cursor: 'pointer', ...defaultIconStyle }}
            onMouseEnter={type === 'hover' ? handleOpen : null}
            onMouseLeave={type === 'hover' ? handleClose : null}
            onClick={type === 'click' ? (open ? handleClose : handleOpen) : null}
          />
        )}
        <Popover
          style={type === 'hover' ? { pointerEvents: 'none' } : {}}
          onClose={handleClose}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={anchorOrigin}
          transformOrigin={transformOrigin}
        >
          <span>{children}</span>
        </Popover>
      </>
    );
  }
);

export default CustomPopover;
